type PLAUSIBLE_TRACKER_EVENT = 'ActionUnclassifiedHeatingSystems' | 'ActionPositionDetermined' | 'ActionProtocolCreated'

declare global {
	function plausible(event: string): void
	function plausible(event: string, object: any): void
}

export const trackPlausibleEvent = (eventName: PLAUSIBLE_TRACKER_EVENT, props?: Record<string, string>) => {
	if (eventName === 'ActionUnclassifiedHeatingSystems') {
		plausible('ActionUnclassifiedHeatingSystems', {
			props,
		})
	} else if (eventName === 'ActionPositionDetermined') {
		plausible('Position determined')
	} else if (eventName === 'ActionProtocolCreated') {
		plausible('Protocol created', { props })
	}
}
